import "./style.css";
import React, { useState, useEffect } from "react";
import loadConfig from "../../Services/apiService";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

export default function TextAreaAHSF(props) {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const [inputValue, setInputValue] = useState(
    props.value == undefined || props.value == ""
      ? props.defaultValue
      : props.value || ""
  );
  //[,]
  //this function to get data from main.json file by fieldsName props
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };

  useEffect(() => {
    dataJson();
  }, []);
  const handleChange = (e) => {
    let fieldsName = props.fieldsName;
    let code = JsonDataa?.JsonData[props.fieldsName];

    let wordsNumber = code.wordsNumber ? code.wordsNumber : 2000;
    console.log(wordsNumber, "code");

    const value = e.target.value;
    let wordsArray = value.trim().split(/\s+/);

    console.log(wordsArray, "lengh");

    if (wordsArray.length <= wordsNumber) {
      setInputValue(value);

      if (props.onChange) {
        props.onChange(e);
      }
    } else {
      let number = wordsArray.slice(0, wordsNumber);
      if (fieldsName == "BI_Activity" || fieldsName == "BI_ItemName") {
        setInputValue(number);
        // console.log(number, "dffdf",wordsNumber);
      } else {
        setInputValue(number.join(" "));
        // console.log(number.join(" "), "dffdf",wordsNumber);
      }

      if (props.onChange) {
        props.onChange(e);
      }
    }
    // props.onChange
  };

  return dataJsonObject ? (
    <>
      {props.show && (
        <div className="containerInputAHSF">
          <div className="label-container">
            <label
              className="labelInput"
              htmlFor={dataJsonObject.code}
              title={dataJsonObject.nameEN}
            >
              {dataJsonObject.nameAR}
              {dataJsonObject.isRequired ? <span>*</span> : ""}
            </label>
            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
                &nbsp;
              </span>
            )}
          </div>
          <textarea
            id={dataJsonObject.code}
            value={inputValue ? inputValue : props.value}
            defaultValue={props.defaultValue}
            placeholder={dataJsonObject.PlaceHolder}
            onChange={(e) => {
              handleChange(e);
            }}
            disabled={props.disabled}
            required={props.required}
            className={props.showValidationMessage ? "textarea-error" : ""}
            onBlur={props.onBlur}
          />
          {/* {props.showValidationMessage && (
            <p className="error-message">{props.validationMessage}</p>
          )} */}
        </div>
      )}
    </>
  ) : (
    ""
  );
}
